"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFeefoScript = void 0;
const tslib_1 = require("tslib");
const ScriptLoaderUtil_1 = tslib_1.__importDefault(require("./ScriptLoaderUtil"));
const ReviewConstants_1 = require("../constants/ReviewConstants");
const loadFeefoScript = (feefoIdentifier) => {
    ScriptLoaderUtil_1.default.loadScript(`https://api.feefo.com/api/javascript/${feefoIdentifier}`, ReviewConstants_1.FEEFO_POPUP_SCRIPT_ID);
};
exports.loadFeefoScript = loadFeefoScript;
